import moment from "moment"

export interface CreatedShortInternshipScheduleArgs {
  id: number
  starts_on: string
  ends_on: string
  entry_deadline: string
  schedule_note: string
  entry_deadline_note: string
  place: string
  address: string
  created_at: string
}

export class ShortInternshipSchedule {
  id: number
  startsOn: string | null
  endsOn: string | null
  entryDeadline: string | null
  scheduleNote: string | null
  entryDeadlineNote: string | null
  capacity: number
  place: string
  address: string
  numberOfApplications: number
  createdAt: string
  beforeEntryDeadline: boolean

  constructor(args: CreatedShortInternshipScheduleArgs) {
    this.id = args.id
    this.startsOn = args.starts_on && moment(args.starts_on).format("YYYY/MM/DD(ddd)")
    this.endsOn = args.ends_on && moment(args.ends_on).format("YYYY/MM/DD(ddd)")
    this.entryDeadline =
      args.entry_deadline &&
      (moment(args.entry_deadline).isAfter(moment())
        ? moment(args.entry_deadline).format("YYYY/MM/DD(ddd) HH:mm")
        : "募集終了")
    this.scheduleNote = args.schedule_note
    this.entryDeadlineNote = args.entry_deadline_note
    this.place = args.place
    this.address = args.address
    this.createdAt = args.created_at
    this.beforeEntryDeadline = moment(args.entry_deadline) > moment()
    // OPTIMIZE: EventSheduleと並列で使用するために不足プロパティを空定義している
    // もっと良いやり方があればリファクタしたい
    this.capacity = 1000
    this.numberOfApplications = 0
  }
}
